module.exports = __webpack_public_path__ + "img/1.acb04487.jpg";